import { render, staticRenderFns } from "./TextsAndDynamicFields.vue?vue&type=template&id=97d8d386&"
import script from "./TextsAndDynamicFields.vue?vue&type=script&lang=js&"
export * from "./TextsAndDynamicFields.vue?vue&type=script&lang=js&"
import style0 from "./TextsAndDynamicFields.vue?vue&type=style&index=0&id=97d8d386&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports